import { defineStore } from 'pinia';
import useOriginalQueryStore from './originalQuery';
import useLocaleStore from './locale';
import smsOptInService from '../services/smsOptInService';

export default defineStore('smsOptinStatus', {
  state: () => ({
    smsOptInStatus: {},
    isSmsStatusLoaded: false,
    smsOptInServiceSuccess: true,
  }),
  getters: {
    getSmsOptInStatus: (state) => state.smsOptInStatus,
    getIsSmsStatusLoaded: (state) => state.isSmsStatusLoaded,
    getSmsOptInServiceSuccess: (state) => state.smsOptInServiceSuccess,
  },
  actions: {
    /**
     * @description Initializes the opt in status from the global scope that was set when the URL
     * loaded
     */
    loadSmsOptInStatus() {
      const { smsOptInStatus, smsOptInServiceSuccess } = window;
      this.smsOptInServiceSuccess = smsOptInServiceSuccess;
      this.smsOptInStatus = smsOptInStatus;
      this.isSmsStatusLoaded = true;
    },
    /**
     * @description Adds an opt-in update and updates state based off the service response
     * @param {string} newStatus The new status to add
     */
    async addOptIn(newStatus) {
      this.isSmsStatusLoaded = false;
      try {
        const storeStatus = this.getSmsOptInStatus;
        const originalQueryStore = useOriginalQueryStore();
        const localeStore = useLocaleStore();
        const { phoneUuid, programKey } = originalQueryStore.getOriginalQuery ?? {};
        const locale = localeStore.getLocale;
        const response = await smsOptInService.addOptIn(
          programKey,
          phoneUuid,
          storeStatus.status,
          newStatus,
          locale,
        );
        this.smsOptInStatus = response.data;
        this.isSmsStatusLoaded = true;
        this.smsOptInServiceSuccess = true;
      } catch (error) {
        this.isSmsStatusLoaded = true;
        this.smsOptInServiceSuccess = false;
      }
    },
  },
});
